import { Text } from '@user-portal/wikr-components';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getCurrencySign, getDiscount, getPriceForCurrency } from 'helpers/prices';

import DiscountOffer from 'components/DiscountOffer';

import { getContent } from './config';
import { IReturnOfferContainerProps } from './types';

import * as S from './styled';

import 'react-toastify/dist/ReactToastify.css';

const ReturnOfferContainer = ({
    handleSubmit,
    subscription,
    oldProduct,
    specialOfferProduct,
    isLoading,
}: IReturnOfferContainerProps) => {
    const { title, subTitle, extraText, firstBadgeText, secondBadgeText, submitButton } = getContent();
    const { t } = useTranslation();

    if (!specialOfferProduct || !oldProduct) return;

    const discount = getDiscount(oldProduct.price, getPriceForCurrency(specialOfferProduct));

    return (
        <S.SurveyContent data-locator="discountOfferContainer">
            <S.DiscountsContainer>
                <Text type="h4" medium center mb={12}>
                    <Trans i18nKey={title} values={{ discount }} components={{ Primary: <span /> }} />
                </Text>
                {subTitle && (
                    <Text type="large-text" center mb={24}>
                        {t(subTitle)}
                    </Text>
                )}
                <DiscountOffer
                    badgeBackgroundColor="surface-hovered"
                    badgeText={t(firstBadgeText)}
                    price={oldProduct.price}
                    periodTitle={t('subscription.cancellation.specialOffer.namePeriodICU', {
                        period: subscription.subscription_period,
                    })}
                    period={subscription.subscription_period}
                    currencySign={getCurrencySign(oldProduct.currency)}
                />
                <DiscountOffer
                    badgeBackgroundColor="critical-default"
                    badgeText={t(secondBadgeText, {
                        discount: discount,
                    })}
                    extraText={t(extraText)}
                    oldPrice={oldProduct.price}
                    price={getPriceForCurrency(specialOfferProduct)}
                    periodTitle={t('subscription.cancellation.specialOffer.namePeriodICU', {
                        period: specialOfferProduct.subscription_period,
                    })}
                    period={specialOfferProduct.subscription_period}
                    currencySign={getCurrencySign(specialOfferProduct.currency)}
                    isNewOffer
                    handleSubmit={handleSubmit}
                    submitButton={t(submitButton)}
                    isLoading={isLoading}
                />
            </S.DiscountsContainer>
        </S.SurveyContent>
    );
};

export default ReturnOfferContainer;
